import React from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
    onBackdropClick: () => void,
    type: String
}

const Modal: React.FC<ModalProps> = ({ onBackdropClick, children, type }) => {
    let modalContent = <></>;
    let modalElementClass = "z-50 flex fixed items-center justify-center bg-gray-400 bg-opacity-40 h-full w-full top-0 left-0";

    switch (type) {
        case "profile":
        case "createKeys":
        case "studentInfo":
        case "memorygame":
        case "result": {
            modalContent = (
                <div className={"fixed inset-1 justify-center max-h-9/10  max-w-3/4 md:max-w-3/4 lg:max-w-3/5 flex m-auto items-center opacity-100 bg-white"} onClick={e => e.stopPropagation()}>
                    {children}
                </div>
            );
            break;
        }
        case "loading":
            modalContent = (
                <div className={"fixed inset-1/4 justify-center max-h-9/10  max-w-3/4 md:max-w-3/4 lg:max-w-3/5 flex m-auto items-center opacity-100 bg-transparent"} onClick={e => e.stopPropagation()}>
                    {children}
                </div>);

            break;
        case "feedBack": {
            modalElementClass = "z-50 flex fixed bg-gray-400 bg-opacity-40 h-full w-full top-0 right-0";

            modalContent = (
                <div className="fixed bottom-3 right-5 3xl:bottom-7 3xl:right-8 4xl:right-14 6xl:right-16 7xl:right-24 7xl:bottom-28 9xl:right-32 h-44 w-44 lg:h-60 lg:w-60 2xl:h-72 2xl:w-72 4xl:h-96 7xl:h-1/3 4xl:w-340px 6xl:w-380px 7xl:w-440px 8xl:w-460px 9xl:w-480px 10xl:w-500px 11xl:h-1/2 11xl:w-525px bg-transparent">
                    <div className={"absolute opacity-100 bg-transparent"} onClick={e => e.stopPropagation()}>
                        {children}
                    </div>
                </div>
            );

            break;
        }
        default: {
            break;
        }
    }

    let modalElement = (
        <div onClick={onBackdropClick} className={modalElementClass} >
            {modalContent}
        </div >
    );

    return ReactDOM.createPortal(
        modalElement, document.getElementById('modal-root')!
    );
}

export default Modal